export class Validators {
  public static required = (value) => {
    let valueTemp = value;

    if (typeof valueTemp == "string") {
      valueTemp = valueTemp.trim();
    }
    return valueTemp || valueTemp === 0 ? undefined : "Pole wymagane";
  };

  public static normalCharacter = (value) => {
    return value &&
      !/^[AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻż\s]+$/i.test(
        value
      )
      ? "Tylko litery, bez specjalnych znaków"
      : undefined;
  };

  public static streetCharacter = (value) => {
    return value &&
      !/^[AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻż\s?:0-9]+$/i.test(
        value
      )
      ? "Bez specjalnych znaków"
      : undefined;
  };

  public static homeNumber = (value) => {
    return value && !/^[0-9]/i.test(value)
      ? "Tylko cyfry, bez specjalnych znaków"
      : undefined;
  };

  public static requiredPremium = (value) => {
    return value != undefined ? undefined : "Pole wymagane";
  };

  public static matchPassword = (value, allValues) => {
    return allValues.password === allValues.confirmation
      ? undefined
      : "Niezgodność hasła";
  };

  public static salesmanValidate = (value, allValues) => {
    if (
      allValues.legalForm == "company" &&
      (!allValues.nip || !allValues.companyName) &&
      !value
    ) {
      return "Pole wymagane";
    }
  };
  public static telephoneMinLength = (value) => {
    // console.log("sprawdzam walidację", value);
    return value && !/^[0-9]{9}/i.test(value)
      ? "Telefon musi zawierać 9 cyfr"
      : undefined;
  };
  public static passwordMinLength = (value) => {
    // const regex = new RegExp('[!@#$%^&*(),.?":{}|<>]');
    // console.log(regex.test(value));
    // return value && value.length < 8 || !regex.test(value) ? `Hasło musi zawierać co najmniej 8 znaków oraz 1 znak specjalny` : undefined;
    return value && value.length < 8
      ? `Hasło musi zawierać co najmniej 8 znaków`
      : undefined;
  };
  public static regon = (value: string) => {
    return value && !/^[0-9]{9}$/i.test(value)
      ? "REGON musi zawierać 9 cyfr"
      : undefined;
  };
  public static nip = (value: string) => {
    return value && !/^[0-9]{10}$/i.test(value)
      ? "NIP musi zawierać 10 cyfr"
      : undefined;
  };
  public static isNumber = (value: string) => {
    const num = value && value.toString().replace(/\./g, "").replace(/,/g, ".");
    return value && isNaN(Number(num)) ? "Wpisz cyfrę" : undefined;
  };
  public static isEmail = (value) =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ? "Niepoprawny adres email"
      : undefined;
  // public static isZipCode = value => (value && !/^\s*?\d{6}(?:[-\s]\d{4})?\s*?$/i.test(value) ? "Niepoprawny format" : undefined);
  public static isZipCode = (value) =>
    value && !/^[0-9]{2}-[0-9]{3}$/i.test(value)
      ? "Niepoprawny format"
      : undefined;
  public static hour = (value) =>
    value && !/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/i.test(value)
      ? "Niepoprawny format"
      : undefined;
  public static year = (value) =>
    // value && !(/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/).test(value)
    value &&
    !/(?:(?:10|11|12|13|14|15|16|17|18|19|20|21|22)[0-9]{2})/.test(value)
      ? "Niepoprawny format"
      : undefined;
}



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/Validators.tsx